import { InjectionToken } from '@angular/core';
import { CacheInterface } from "../lib/services/CacheInterface";

export const ENVIRONMENT_TOKEN = new InjectionToken('environment');
export const GOOGLE_ANALYTICS_TOKEN = new InjectionToken('google-analytics');
export const OFFLINE_CACHE_SERVICE = new InjectionToken<CacheInterface>('offline-cache-service');
